export default __webpack_public_path__ + "static/media/cc_ltGray.0519c452.jpg";